// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__7fs8K","row":"Node_row__2Dnn7","label":"Node_label__2hUoh","footer":"Node_footer__2uJ6G"};